export default "__VITE_ASSET__997fdf54__"